import { _apiV2_delete, _apiV2_get, _apiV2_post } from "@/app/api2"
import { mainLogger as log } from "@/app/logger"
import {
  CreateCustomList,
  CustomList,
  CustomListChange,
  CustomListHistory,
  CustomListMetrics,
  Interval,
} from "@/app/types"

export async function fetchCustomLists(): Promise<CustomList[]> {
  return _apiV2_get("/lists", {
    key: "customLists",
  })
}

export async function createCustomList(
  data: CreateCustomList
): Promise<CustomList> {
  return _apiV2_post("/lists", {
    key: "createCustomList",
    body: data,
  })
}

export async function getCustomList(listKey: string): Promise<CustomList> {
  return _apiV2_get(`/lists/${listKey}`, {
    key: "getCustomList",
  })
}

export async function updateCustomList(
  listKey: string,
  data: CustomListChange
): Promise<CustomList> {
  return _apiV2_post(`/lists/${listKey}`, {
    key: "createCustomListChange",
    body: data,
  })
}

export async function removeCustomList(listKey: string): Promise<CustomList[]> {
  return _apiV2_delete(`/lists/${listKey}`, {
    key: "removeCustomList",
  })
}

export async function getCustomListMetrics(
  listKey: string,
  interval: string,
  filter: string
): Promise<CustomListMetrics | void> {
  try {
    const isIntervalValid = Interval.isValidInterval(interval)
    if (!isIntervalValid) throw new Error("Invalid interval provided.")

    const response: CustomListMetrics = await _apiV2_get(
      `/lists/${listKey}/${interval}`,
      {
        key: `customListMetrics(${listKey}, ${interval})`,
        cacheLS: true,
        queryParam: { filter },
      }
    )

    if (response) {
      const isFund = response.list.listType === "FUND"
      const areCustomListMetricsValid =
        response[isFund ? "fundsets" : "firmsets"]?.custom !== null

      if (!areCustomListMetricsValid)
        throw new Error("Custom list metrics cannot be null.")
      else return response
    }
  } catch (error) {
    log.error("Error fetching custom list metrics:", error)
    throw error
  }
}

export async function getCustomListHistory(
  listKey: string
): Promise<CustomListHistory> {
  return _apiV2_get(`/lists/${listKey}/history`, {
    key: `customListHistory(${listKey})`,
  })
}
